import { ReactNode, useEffect } from 'react';
import { ThemeProvider } from '@pu/mpp-ui/themes';
import {
  CHANNEL_APPLE_TOUCH_ICONS,
  CHANNEL_FAVICONS,
  CHANNEL_MANIFESTS,
  CHANNEL_META_LINKS,
} from 'core/constants/theme.constants';
import useTheme from 'shared/hooks/use-theme';

const upsertHeadLink = (rel: string, href: string) => {
  let link = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }

  link.setAttribute('href', href);
};

const upsertHeadMeta = (name: string, content: string) => {
  let meta = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }

  meta.setAttribute('content', content);
};

const ThemeContainer = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();

  const { channelId, channelTheme, selectedTheme } = theme;

  useEffect(() => {
    if (channelId && channelTheme.name) {
      document.documentElement.setAttribute('data-theme', channelTheme.name); // NOSONAR
      document.title = channelTheme.title;
      upsertHeadLink('icon', CHANNEL_FAVICONS[channelId]);
      upsertHeadLink('manifest', CHANNEL_MANIFESTS[channelId]);
      upsertHeadLink('apple-touch-icon', CHANNEL_APPLE_TOUCH_ICONS[channelId]);
      upsertHeadMeta('twitter:image', `${CHANNEL_META_LINKS[channelId]}?v=${__APP_VERSION__}`);
    }
  }, [channelId, channelTheme.name, channelTheme.title]);

  return <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>;
};

export default ThemeContainer;
